import { render, staticRenderFns } from "./other-cancel-appointments.vue?vue&type=template&id=ee16d1d4&"
import script from "./other-cancel-appointments.vue?vue&type=script&lang=js&"
export * from "./other-cancel-appointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports